import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=5555fdbe&"
import script from "./empty.ts?vue&type=script&lang=ts&"
export * from "./empty.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports